export const environment = {
  production: false,
  version: '26.1008.220009',
  languages: {},
  sec: {
    secMode: 'DEFAULT',
    appID: 17,
    mainToken: 'APPUSEV2',
  },
  rest: {
    /* Url-placeholder */
    LoginUrl: 'https://www.myexcon.com/srv/sec/',
    // ServiceUrl: 'http://localhost:55226/',
    ServiceUrl: 'https://www.myexcon.com/srv/clama/exaktv2/',
    ExternalServiceUrl: 'https://www.myexcon.com/srv/clama/external/exakt/',
    // LerfServiceUrl: 'https://www.myexcon.com/srv/common/leistungserfassung/',
    ReportUrl: 'https://www.myexcon.com/exakt/ui/bericht/index.html#',
    PdfViewerUrl: 'https://www.myexcon.com/srv/common/syncfusion/api/pdfviewer',
    SpreadsheetUrl: 'https://www.myexcon.com/srv/common/syncfusion/api/spreadsheet',
    /* Max-Filesize */
    MAXFILESIZE: 10485760, // 10 - MeBiByte | 10.48576 MB

    Endpoints: {
      /* Global User */
      Identitaet: '$$LoginUrl$${uid}/identitaet',
      // PasswordSettings: 'PasswordSettings',
      /* Report */
      ReportModuleNewReport: '$$ReportUrl$$/FB/{vorgID}/',
      ReportModuleOpenReport: '$$ReportUrl$$/Bericht/details/{fbaID}',
      /* Global Search */
      GlobalSearch: '{uid}/globalsearch/{searchValue}',
      /* ImageThumbnail */
      ImageThumbnail: '{uid}/document/{dokID}/imgbin?thumb=50',
      ImageThumbnail120: '{uid}/document/{dokID}/imgbin?thumb=120',
      ImageThumbnailBig: '{uid}/document/{dokID}/imgbin',
      /* Repository */
      RepositoryR_Summary: '{uid}/repository',
      /* OE R_Lists */
      OeR_List_User: '{uid}/oe/user',
      OeR_List_Company: '{uid}/oe/company',
      OER_List_CrmRolle: '{uid}/oe/rolle/{oe_CrmRolle}',
      OER_List_CrmRolle_Parent: '{uid}/oe/{oe_CrmRolle}/{parentOEID}',
      OER_List_CrmRolle_Parent_OETyp: '{uid}/oe/{oe_CrmRolle}/{parentOEID}/{oe_enmIdent_OETyp}',
      /* History List */
      HistoryR_List: '{uid}/history/{fkID}',
      /* Document */
      DocumentC: '{uid}/document/{dok_objID}/attachment',
      DocumentR_List: '{uid}/object/{objID}/document',
      DocumentR_List_PhotoDoc: '{uid}/object/{objID}/document/photodoc/{hideOriginals}',
      DocumentR_List_Jag: '{uid}/object/{objID}/document/jag',
      DocumentR: '{uid}/document/{dokID}',
      DocumentR_Summary: '{uid}/document/{dokID}/summary',
      DocumentU: '{uid}/document/{dokID}',
      DocumentU_File: '{uid}/document/{dokID}/file',
      DocumentD: '{uid}/document/{dokID}/delete',
      EnumerationR_DocType: '{uid}/enumeration/docType',
      EnumerationR_DocAttrType: '{uid}/enumeration/docAttrType',
      /* Case -- Auftrag */
      CaseC: '{uid}/case',
      CaseR_List: '{uid}/case',
      CaseR_Summary: '{uid}/case/{auID}/summary',
      Case_Report: '{uid}/case/{auID}/receiptReport',
      Case_Report_fileTypeEx: '{uid}/case/{auID}/receiptReport/{fileType}/{extensions}',
      Case_Report_fileType: '{uid}/case/{auID}/receiptReport',
      Case_ReportData: '{uid}/case/{auID}/receiptReport/Data',
      CaseU: '{uid}/case/{auID}/update',
      CaseU_ObjectPic: '{uid}/case/{auID}/objectPic',
      CaseU_LastQSAuditor: '{uid}/case/{auID}/LastQSAuditor/{oeID}',
      TaskR_Disposition: '{uid}/case/{auID}/disposition',
      CaseU_Check: '{uid}/case/{auID}/check',
      CaseU_StateManual: '{uid}/case/{auID}/setManualState',
      CaseU_SetOE: '{uid}/case/{auID}/setOE',
      CaseU_SetWAnsprOE: '{uid}/case/{auID}/setWAnsprOE',
      CaseCloneC: '{uid}/case/clone',
      /* Task -- Vorgang */
      TaskC: '{uid}/task',
      TaskR_List: '{uid}/task',
      TaskR_Summary: '{uid}/task/{vorgID}/summary',
      TaskR_Placeholder: '{uid}/task/{vorgID}/placeholder',
      TaskU_MultiAssign: '{uid}/task/multiAssign',
      TaskU_Complete: '{uid}/task/{vorgID}/complete',
      TaskU_Cancel: '{uid}/task/{vorgID}/cancel',
      TaskU_Accept: '{uid}/task/{vorgID}/accept',
      TaskU_Decline: '{uid}/task/{vorgID}/decline',
      TaskU_Finish: '{uid}/task/{vorgID}/finish',
      TaskU_ContactAttempt: '{uid}/task/{vorgID}/contactAttempt/{auID}',
      TaskU_Check: '{uid}/task/{vorgID}/check',
      TaskU_Edit: '{uid}/task/{vorgID}/edit',
      TaskU_StateManual: '{uid}/task/{vorgID}/manual',
      Task_WFSendToApp: '{uid}/task/{vorgID}/workflow/sendtoapp',
      Task_WFInitSchedule: '{uid}/task/{vorgID}/workflow/scheduleinit',
      Task_WFDispoToMe: '{uid}/task/{vorgID}/workflow/dispotome',
      Task_WFSendToQS: '{uid}/task/{vorgID}/workflow/sendtoqs',
      Task_WFQSReturn: '{uid}/task/{vorgID}/workflow/qsreturn',
      Task_WFQSRegFinish: '{uid}/task/{vorgID}/workflow/qsregfinish',
      ScheduleItemC: '{uid}/scheduleitem',
      ScheduleItemU: '{uid}/scheduleitem/{apiID}',
      ScheduleItemD: '{uid}/scheduleitem/{apiID}/delete',
      TaskU_FinalComplete: '{uid}/task/{vorgID}/finalcomplete',
      TaskU_CoEditor: '{uid}/task/{vorgID}/coeditor/{oeID}',
      TaskU_Editor: '{uid}/task/{vorgID}/editor/{oeID}',
      Task_Report: '{uid}/task/{vorgID}/receiptReport',
      Task_Report_fileTypeEx: '{uid}/task/{vorgID}/receiptReport/{fileType}/{extensions}',
      Task_Report_fileType: '{uid}/task/{vorgID}/receiptReport',
      Task_ReportData: '{uid}/task/{vorgID}/receiptReport/Data',
      DialogFrageR_List: '{uid}/task/{vorgID}/dialogFrage',
      TaskReceiptC_FromDokument: '{uid}/task/{vorgId}/receipt',
      TaskDispositionR_Summary: '{uid}/task/{vorgID}/disposition',
      AddVNDataC: '{uid}/case/{auID}/addvndata',
      /* Dialog -- Ergebnis */
      DialogErgebnisCU: '{uid}/dialogueanswer/{oid}',
      /* Note -- Notiz */
      NoteR: '{uid}/note/{ntzID}',
      NoteC: '{uid}/note',
      NoteU: '{uid}/note/{ntzID}',
      NoteD: '{uid}/note/{ntzID}',
      /* Report */
      ReportR_List: '{uid}/report',
      /* Ablaufplan */
      AblaufplanR_List: '{uid}/scheduleitem',
      /* DokumentTemplate */
      DocumentTemplateR_List: '{uid}/documenttemplate',
      DocumentTemplateR: '{uid}/documenttemplate/{dotID}',
      /* Receipt */
      ReceiptR_List: '{uid}/receipt',
      ReceiptR_List_FKID: '{uid}/receipt/{FKID}/list',
      ReceiptR: '{uid}/receipt/{rcptID}',
      ReceiptR_Duplicates: '{uid}/receipt/{rcptID}/duplicates',
      ReceiptR_Binary: '{uid}/receipt/{rcptID}/binary',
      ReceiptR_BinaryAnnotated: '{uid}/receipt/{rcptID}/binary/annotated',
      ReceiptR_Checkview: '{uid}/receipt/{rcptID}/checkview',
      ReceiptR_AiStatus: '{uid}/receipt/{rcptID}/aistatus',
      ReceiptC: '{uid}/receipt',
      ReceiptC_Merge: '{uid}/receipt/merge',
      ReceiptC_MergeByDokIDs: '{uid}/receipt/mergeDokIDs',
      ReceiptCU_FileAnnotated: '{uid}/receipt/{rcptID}/annotated',
      ReceiptD_File: '{uid}/receipt/{rcptID}/file',
      ReceiptD: '{uid}/receipt/{rcptID}',
      ReceiptU: '{uid}/receipt/{rcptID}',
      ReceiptU_Annotation: '{uid}/receipt/{rcptID}/annotation',
      ReceiptU_Review: '{uid}/receipt/{rcptID}/review',
      ReceiptU_RevokeState: '{uid}/receipt/{rcptID}/RevokeState',
      ReceiptR_Review: '{uid}/receipt/{rcptID}/review',
      ReceiptU_Pick: '{uid}/receipt/{rcptID}/Review/pick',
      ReceiptCommentary: '{uid}/receipt/{rcptID}/commentary',
      ReceiptCompanyCU: '{uid}/receipt/{rcptID}/company',
      ReceiptCompanyU: '{uid}/receipt/{rcptID}/company/{compID}',
      ReceiptCU_File: '{uid}/receipt/{rcptID}/original',
      ReceiptCompanyLinkCUD: '{uid}/receipt/{rcptID}/company/{compID}/link',
      ReceiptU_FinishRV: '{uid}/receipt/{rcptID}/finishRV',
      ReceiptU_RestoreDetails: '{uid}/receipt/{rcptID}/restoreDetails',
      ReceiptU_AddFile: '{uid}/receipt/{rcptID}/addFile',
      // Receipt Statement
      ReceiptU_switchModule: '{uid}/receipt/{rcptID}/switchModule',
      ReceiptR_Statement_review: '{uid}/receipt/{rcptID}/statementReview',
      // Annotation
      ReceiptAnnotationU: '{uid}/receipt/{rcptID}/annotation/{annotationID}',
      ReceiptAnnotationLock: '{uid}/receipt/{rcptID}/annotation/{annotationID}/lock',
      ReceiptCorrectionC: '{uid}/receipt/{rcptID}/correction',
      ReceiptCorrectionU: '{uid}/receipt/{rcptID}/correction/{annotationID}',
      ReceiptCorrectionD: '{uid}/receipt/{rcptID}/correction/{annotationID}',
      ReceiptNoteC: '{uid}/receipt/{rcptID}/note',
      ReceiptNoteU: '{uid}/receipt/{rcptID}/note/{annotationID}',
      ReceiptNoteD: '{uid}/receipt/{rcptID}/note/{annotationID}',
      // Nachricht
      MessageR_List: '{uid}/message',
      MessageC: '{uid}/message',
      MessageAttachmentC: '{uid}/message/{msgID}/attachmentupload',
      MessageContactList: '{uid}/message/contact',
      MessageR_Repository: '{uid}/message/repository',
      TextblockR_Filled: '{uid}/textblock/{tbID}/filled',
      MessageR_Summary: '{uid}/message/{msgID}',
      MessageU_Done: '{uid}/message/{msgID}/done',
      MessageU_SetCategory: '{uid}/message/{msgID}/category',
      MessageU_RecipientSetRead: '{uid}/message/{msgID}/setread',
      MessageLinkCUD: '{uid}/message/{msgID}/link/{lnkType}',
      DefaultMessageR_Filled: '{uid}/defaultmessage/{dmsgID}/filled/{objID}',
      DefaultMessageR_FilledNEW: '{uid}/defaultmessage/{dmsgID}/fillednew/{objID}',
      //  Company
      CompanyR_List: '{uid}/company',
      CompanyGROOT: '{uid}/company/{compID}',
      CompanyDuplicates: '{uid}/company/duplicates',
      //  Home | Dashboard
      HomeR_Summary: '{uid}/Home',
      HomeR_Ablaufplan: '{uid}/Home/Ablaufplan',
      DashboardR_Summary: '{uid}/Dashboard',
      // Reference
      ReferenceR_List: '{uid}/reference/{auID}',
      ReferenceR_ListVorgang: '{uid}/reference/{vorgID}/task',
      ReferenceR_ListReceipt: '{uid}/reference/{rcptID}/receipt',
      ReferenceC: '{uid}/reference',
      Reference_Group: '{uid}/reference/group',
      Reference_Item: '{uid}/reference/item',
      ReferenceC_Group: '{uid}/reference/group',
      ReferenceC_Item: '{uid}/reference/item',
      ReferenceU_Group: '{uid}/reference/group/{refID}',
      ReferenceU_Item: '{uid}/reference/item/{refID}',
      ReferenceD_Group: '{uid}/reference/group/{refID}',
      ReferenceD_Item: '{uid}/reference/item/{refID}',
      // Disposition
      DispositionR_Summary: '{uid}/disposition',
      DispositionSchadenOrtR_List: '{uid}/dispositionSchadenOrt',
      // Document Management
      DocumentZip: '{uid}/document/zip',
      DocumentLinkCU: '{uid}/document/link',
      DocumentUnLinkU: '{uid}/document/{objID}/unlink',
      DocumentCloneC: '{uid}/document/clone',
      // Disposition Einstellungen
      OER_Benutzer_BonusMalusQuestionareR_List: '{uid}/oe/{oeID}/bonusmalusquestionare',
      // Userspezifische Calls
      BonusMalusQuestionareR: '{uid}/bonusmalusquestionare/{bmqID}',
      BonusMalusQuestionareC: '{uid}/bonusmalusquestionare',
      BonusMalusQuestionareU: '{uid}/bonusmalusquestionare/{bmqID}',
      OEBenutzerDashboardR_Summary: '{uid}/oe/{oeID}/user/dashboard',
      Dispositionsettings: '{uid}/user/{oeID}/dispositionsettings',
      // Library
      LibraryList: '{uid}/lib',
      LibraryDetail: '{uid}/lib/{libID}',
      LibraryC: '{uid}/lib/{clID}',
      LibraryC_NewDirectory: '{uid}/lib/{clID}/directory',
      LibraryC_File: '{uid}/lib/{clID}/file/{RootKey}',
      LibraryU: '{uid}/lib/{libID}',
      LibraryD: '{uid}/lib/{libID}',
      LibraryStream: '{uid}/lib/{libID}/stream',
      // Settings
      GlobalSettingsR_Summary: '{uid}/settings/global',
      GlobalSettingsU: '{uid}/settings/global',
      TextbausteinR_List: '{uid}/settings/autotext/{mode}',
      TextbausteinC: '{uid}/settings/autotext/{mode}',
      TextbausteinU: '{uid}/settings/autotext/{tbID}',
      TextbausteinD: '{uid}/settings/autotext/{tbID}',
      UserStempelR_List: '{uid}/user/stempel',
      UserStempelC: '{uid}/user/stempel',
      UserStempelD: '{uid}/user/stempel/{stpID}',
      UserStempelU: '{uid}/user/stempel/{stpID}',
      UserStempelR: '{uid}/user/stempel/{stpID}/detail',
      UserTextbausteineC: '{uid}/user/textvorlagen',
      UserTextbausteineR_List: '{uid}/user/textvorlagen',
      UserTextbausteineU: '{uid}/user/textvorlagen/{tbID}',
      UserTextbausteineD: '{uid}/user/textvorlagen/{tbID}',
      // OE
      OEListSummary: '{uid}/oe',
      OESummary: '{uid}/oe/{oeID}',
      OESummary_Short: '{uid}/oe/{oeID}/short',
      OERListTyp: '{uid}/oe/typ/{oeTyp}',
      OEGroupRListTyp: '{uid}/oe/group',
      OECompanyRListTyp: '{uid}/oe/company',
      // CRM
      AdresseR: '{uid}/address/{adrID}',
      OeC: '{uid}/oe',
      OeU: '{uid}/oe/{oeID}',
      OEQuestionnaireCUD: '{uid}/oe/{oeID}/questionnaire',
      OeContactCUD: '{uid}/oe/{oeID}/contact',
      OeAdresseCUD: '{uid}/oe/{oeID}/address',
      OeAdresseC_Schadenort: '{uid}/oe/{oeID}/schadenort',
      OeAdresseR_List: '{uid}/oe/{oeID}/address',
      OeAddressR_List_AdresseTyp: '{uid}/oe/{oeID}/address/{adr_enmIdent_AdresseTyp}',
      OeGroupCUD: '{uid}/oe/{oeID}/group/{grpID}',
      OeMemberCUD: '{uid}/oe/{parent_oeID}/child/{child_oeID}',
      OECalculationCUD: '{uid}/oe/{oeID}/calculation',
      OEFormularTemplateCUD: '{uid}/oe/{oeID}/formularTemplate',
      OeLogoC: '{uid}/oe/{oeID}/logo',
      // QuestionnaireRenderer
      QuestionnaireR_List_Chapters: '{uid}/QuestionnaireConfig/{qcnfID}/QuestionnaireVersion/{qverID}',
      QuestionnaireResultR_List: '{uid}/QuestionnaireConfig/{qcnfID}/QuestionnaireVersion/{qverID}/Chapter/{questID}/Result',
      QuestionnaireResultC: '{uid}/QuestionnaireResult',
      QuestionnaireResultU: '{uid}/QuestionnaireResult',
      QuestionnaireResultD: '{uid}/QuestionnaireResult',
      QuestionnaireResultAttachmentR_List: '{uid}/QuestionnaireVersion/{qverID}/Question/{FKID}/Attachment',
      QuestionnaireResultAttachmentR: '{uid}/QuestionResultAttachment/{ID}',
      QuestionnaireResultAttachmentC: '{uid}/QuestionnaireVersion/{qverID}/Question/{FKID}/Attachment',
      QuestionnaireResultAttachmentD: '{uid}/QuestionResultAttachment/{ID}',
      QuestionnaireResultStatistics: '{uid}/QuestionnaireVersion/{qverID}/Statistics',
      QuestionnaireVersionR_Report: '{uid}/QuestionnaireVersion/{qverID}/Report/Excel',
      QuestionnaireVersionR_Summary_Report: '{uid}/QuestionnaireVersion/{qverID}/Report/PDF',
      // QuestionnaireEditor
      QuestionnaireR_List_Editor: '{uid}/QuestionnaireConfig/{qcnfID}/Questionnaire',
      QuestionnaireEditorR_Report: '{uid}/QuestionnaireConfig/{qcnfID}/Editor/Report',
      QuestionnaireC_List: '{uid}/QuestionnaireConfig/{qcnfID}/Questionnaire',
      // QuestionnaireExaktExclusive
      QuestionnaireVersionC: '{uid}/Vorgang/{vorgID}/QuestionnaireConfig/{qcnfID}',
      QuestionnaireVersionR: '{uid}/QuestionnaireVersion/{qverID}',
      QuestionnaireVersionD: '{uid}/QuestionnaireVersion/{qverID}',
      QuestionnaireVersionR_List: '{uid}/QuestionnaireVersion/{FKID}/list',
      QuestionnaireVersionU: '{uid}/QuestionnaireVersion/{qverID}',
      QuestionnaireConfigR_List: '{uid}/QuestionnaireConfig/list',
      QuestionnaireConfigR_List_OE: '{uid}/QuestionnaireConfig/{oeID}/list',
      // Formular
      FormularTemplateR: '{uid}/FormularTemplate/{frmTID}',
      FormularTemplateU: '{uid}/FormularTemplate/{frmTID}',
      FormularTemplateD: '{uid}/FormularTemplate/{frmTID}',
      FormularTemplateR_Binary: '{uid}/FormularTemplate/{frmTID}/binary',
      FormularTemplateU_File: '{uid}/FormularTemplate/{frmTID}/file',
      FormularVersionC: '{uid}/FormularVersion/{frmTID}',
      FormularVersionR: '{uid}/FormularVersion/{frmVID}',
      FormularVersionU: '{uid}/FormularVersion/{frmVID}',
      FormularVersionD: '{uid}/FormularVersion/{frmVID}',
      FormularVersionR_Binary: '{uid}/FormularVersion/{frmVID}/binary',
      FormularVersionCU_File: '{uid}/FormularVersion/{frmVID}/file',
      FormularVersionC_SignedPDF: '{uid}/FormularVersion/{frmVID}/signedpdf',
      // PDF Manger
      PDFSplit: '{uid}/pdf/split/{dokID}',
      // ThumbnailMock
      ThumbnailR_List: '{uid}/thumblist',
      // Calculation
      CalculationVersionC: '{uid}/Vorgang/{fkid}/CalculationTemplate/{cv_ctID}',
      CalculationVersionR: '{uid}/CalculationVersion/{cvID}',
      CalculationVersionR_List: '{uid}/CalculationVersion/{FKID}/list',
      CalculationVersionU: '{uid}/CalculationVersion/{cvID}',
      CalculationVersionD: '{uid}/CalculationVersion/{cvID}',
      CalculationTemplateC: '{uid}/CalculationTemplate',
      CalculationTemplateR: '{uid}/CalculationTemplate/{ctID}',
      CalculationTemplateR_List: '{uid}/CalculationTemplate/list',
      CalculationTemplateR_List_OE: '{uid}/CalculationTemplate/{oeID}/list',
      CalculationTemplateU: '{uid}/CalculationTemplate/{ctID}',
      CalculationTemplateD: '{uid}/CalculationTemplate/{ctID}',
      CalculationVersionR_Preview: '{uid}/CalculationVersion/{cvID}/preview',
      CalculationVersionC_ExportSheet: '{uid}/CalculationVersion/{cvID}/exportSheets',
      CalculationVersionR_DownloadSheet: '{uid}/CalculationVersion/{cvID}/downloadSheets',
      CalculationVersionC_SignedPDF: '{uid}/CalculationVersion/{cvID}/signedpdf',
      // PhotoDocumentation
      PhotoDocumentationC: '{uid}/PhotoDoc/{FKID}',
      PhotoDocumentationR_Download: '{uid}/PhotoDoc/{pdID}/download',
      PhotoDocumentationR_List: '{uid}/PhotoDoc/{FKID}/list',
      PhotoDocumentation_Download: '{uid}/PhotoDoc/download',
      PhotoDocumentationR_Preview: '{uid}/PhotoDoc/{pdID}/preview',
      PhotoDocumentationU: '{uid}/PhotoDoc/{pdID}/update',
      PhotoDocumentationD: '{uid}/PhotoDoc/{pdID}',

      // BerichtsBuilder
      BerichtsBuilderC: '{uid}/BerichtsBuilder/{bbID}',
      BerichtsBuilder_Download: '{uid}/BerichtsBuilder/download',
      BerichtsBuilderC_SingleDokument: '{uid}/BerichtsBuilder/{dok_objID}/save',
      BerichtsBuilderC_Dokument: '{uid}/BerichtsBuilder/save',
      BerichtsBuilderPreviewC: '{uid}/Berichtsbuilder/preview',
      BerichtsBuilderPreviewR: '{uid}/Berichtsbuilder/preview/{rbuipID}',
      BerichtsBuilderPreviewR_List: '{uid}/Berichtsbuilder/preview/{rbuipID}/list',
      ReportCommentaryR_List: '{uid}/Berichtsbuilder/{FKID}/commentary/list',
      ReportCommentaryC: '{uid}/Berichtsbuilder/{FKID}/{commReportType}/commentary',
      BerichtsBuilder_Templates: '{uid}/BerichtsBuilder/{oeID}/templates',
      BerichtsBuilder_TemplatePreview: '{uid}/BerichtsBuilder/templates/{streamId}/preview',

      // Templates
      ReportTemplateStructure: '{uid}/ReportTemplate/{oeID}/Structure',
      ReportTemplateC: '{uid}/ReportTemplate/{oeID}',
      ReportTemplateD: '{uid}/ReportTemplate/{oeID}/{streamId}',
      ReportTemplateR: '{uid}/ReportTemplate/{streamId}/preview',

      // GDV
      GDVReceiptC: '{uid}/case/{auID}/gdvReceipt',

      AIQueueC: '{uid}/AIQueue/{kiqtype}',
      JWTR: '$$ExternalServiceUrl$$jwtOwn',

      // EML
      TESTGetEML: '{uid}/eml/{id}',
      JournalMailR_EML: '{uid}/journalmail/{jmID}/eml',

      // Leistungserfassung
      // LerfTaskList: '$$LerfServiceUrl$${uid}/task',
      // LerfAuftragTaskList: '$$LerfServiceUrl$${uid}/Auftrag/{auID}/task',
      // LerfAuftragList: '$$LerfServiceUrl$${uid}/Auftrag',
      LeistungserfassungList: '{uid}/Leistungserfassung',

      LeistungserfassungListApproved: '{uid}/Leistungserfassung/Freigegeben',
      LeistungserfassungListCanceled: '{uid}/Leistungserfassung/Storniert',
      LeistungserfassungSummary: '{uid}/Leistungserfassung/{leID}/Summary',
      LeistungserfassungCreate: '{uid}/Leistungserfassung',
      LeistungserfassungUpdate: '{uid}/Leistungserfassung',
      LeistungserfassungDelete: '{uid}/Leistungserfassung',
      LeistungserfassungUpdateName: '{uid}/LeistungserfassungName',
      LeistungserfassungUpdatePicker: '{uid}/LeistungserfassungPicker',
      LeistungserfassungUpdateCancel: '{uid}/LeistungserfassungCancel',
      LeistungserfassungUpdateRestore: '{uid}/LeistungserfassungRestore',
      LeistungserfassungR_Report: '{uid}/Leistungserfassung/{leID}/Report',
      LeistungserfassungLeistungRList: '{uid}/LeistungserfassungLeistung/{leID}/List',
      LeistungserfassungLeistungCreate: '{uid}/LeistungserfassungLeistung',
      LeistungserfassungLeistungUpdate: '{uid}/LeistungserfassungLeistung',
      LeistungserfassungLeistungDelete: '{uid}/LeistungserfassungLeistung',
      LeistungserfassungKommentarR_List: '{uid}/Leistungserfassung/{ID}/Kommentar',
      LeistungserfassungKommentarC: '{uid}/Leistungserfassung/{ID}/Kommentar',
      LeistungserfassungAttachmentC: '{uid}/Leistungserfassung/{FKID}/Dokument',
      LeistungserfassungAttachmentR: '{uid}/LeistungserfassungAttachment/{ID}',
      LeistungserfassungAttachmentR_List: '{uid}/LeistungserfassungAttachment/{FKID}/List',
      LeistungserfassungAttachmentD: '{uid}/LeistungserfassungAttachment',
      // LerfDashboardSummary: '$$LerfServiceUrl$${uid}/Dashboard',
      // LeistungsverzeichnisR_List: '$$LerfServiceUrl$${uid}/Leistungsverzeichnis/{clID}/List',
      // LeistungsverzeichnisC: '$$LerfServiceUrl$${uid}/Leistungsverzeichnis',
      // LeistungsverzeichnisU: '$$LerfServiceUrl$${uid}/Leistungsverzeichnis',
      // LeistungsverzeichnisD: '$$LerfServiceUrl$${uid}/Leistungsverzeichnis',
      // LeistungsverzeichnisLeistungR_List: '$$LerfServiceUrl$${uid}/LeistungsverzeichnisLeistung/{lvID}/List',
      // LeistungsverzeichnisLeistungC: '$$LerfServiceUrl$${uid}/LeistungsverzeichnisLeistung',
      // LeistungsverzeichnisLeistungU: '$$LerfServiceUrl$${uid}/LeistungsverzeichnisLeistung',
      // LeistungsverzeichnisLeistungD: '$$LerfServiceUrl$${uid}/LeistungsverzeichnisLeistung',
      // LerfClientR_List: '$$LerfServiceUrl$${uid}/Client',
    }
  }
};
